import React from "react";
import moment from "moment";
import { useDispatch } from "react-redux";

import { removeFormErrors } from "store/form/actions";

import Input from "components/Input";
import Field from "components/Field";
import InputRow from "components/Input/Row";
import Button from "components/Button";
import Accordion from "components/Accordion";

import { useStateSelector } from "utils/field";
import Actions from "../Actions";

import sharedClasses from "features/Model/sharedStyles.module.scss";

const Grant = ({ accessor, change }) => {
    const dispatch = useDispatch();

    const grants = useStateSelector(`${accessor}`) || {
        _firstGrant: {
            amount: null,
            grantType: "",
            note: "",
        },
    };

    const addGrant = () => {
        change(`${accessor}`, {
            ...grants,
            [`${moment().format("YYYYMMDDHHmmssSS")}`]: {
                amount: null,
                grantType: "",
                note: "",
            },
        });
    };

    const removeGrant = (grant) => {
        const { [grant]: removedObj, ...remainingGrantObj } = grants;
        change(`${accessor}`, {
            ...remainingGrantObj,
        });
        dispatch(removeFormErrors(`${accessor}.${grant}`));
    }; 

    return (
        <>
            {Object.keys(grants).map((grant, ind) => {
                const grantAmount = grants[grant]?.amount || 0;
                const hasGrantAmount = !!grantAmount;
                const label = `Grant${hasGrantAmount ? ": $" + grantAmount.toFixed(2) : ""}`;

                return (
                    <Accordion
                        key={`${grant}-${ind}`}
                        className={sharedClasses.accordion}
                        heading={<span>{label}</span>}
                        large
                        hoverActions={
                            <Actions
                                accessor={accessor}
                                change={change}
                                handleDelete={() => removeGrant(grant)}
                                type="grant"
                            />
                        }
                    >
                        <div>
                            <InputRow gridTemplate="1fr 2fr">
                                <Field
                                    component={Input}
                                    name={`${accessor}.${grant}.amount`}
                                    label={`Grant Amount ($)`}
                                    type="number"
                                />
                                <Field
                                    component={Input}
                                    name={`${accessor}.${grant}.description`}
                                    label={`Description/Program`}
                                    type="text"
                                    disabled={!hasGrantAmount}
                                />
                            </InputRow>
                        </div>
                    </Accordion>
                );
            })}
            <Button
                onClick={() => {
                    addGrant();
                }}
            >
                Add New Grant
            </Button>
        </>
    );
};

export default Grant;
